// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ReadingViewAll.module.css */
.ReadingViewAll_container__LUc1z {
  max-width: 100%;
  margin-bottom: 2rem;
}

/* Showcase Styles */
.ReadingViewAll_showcase__dycMG {
  min-height: 90vh;
  position: relative;
}

.ReadingViewAll_showcaseSwiper__hvBcL {
  height: 90vh;
}

.ReadingViewAll_showcaseSlide__GyR7O {
  position: relative;
  height: 90vh;
  overflow: hidden;
}

.ReadingViewAll_backgroundImage__99fyk {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
}

.ReadingViewAll_backgroundImage__99fyk::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.ReadingViewAll_contentWrapper__ItHr1 {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  gap: 4rem;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), #1a1a1a);

}

.ReadingViewAll_bookDetails__bAq5Y {
  flex: 1 1;
  color: white;
  max-width: 600px;
}

.ReadingViewAll_title__7gKHM {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 1rem;
  line-height: 1.2;
}

.ReadingViewAll_author__SEBZu {
  font-size: 16px;
  margin-bottom: 1rem;
  opacity: 0.9;
}

.ReadingViewAll_category__A4KHD {
  display: inline-block;
  padding: 0.5rem 1rem;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  margin-bottom: 1.5rem;
  cursor: pointer;
}

.ReadingViewAll_description__C0Kji {
  font-size: 12px;
  line-height: 1.6;
  margin-bottom: 2rem;
  opacity: 0.8;
}

.ReadingViewAll_stats__r2oD3 {
  display: flex;
  gap: 2rem;
  font-size: 12px;
  opacity: 0.7;
}

.ReadingViewAll_coverImageContainer__8bumn {
  flex: 0 0 auto;
  width: 400px;
  height: auto;
  max-height: 500px;
  position: relative;
}

.ReadingViewAll_coverImage__M1u\\+d {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

/* Grid Section Styles */
.ReadingViewAll_booksGrid__j77KZ {
  width: 100%;
  max-width: 95%;
  margin: 0 auto;
 
}

.ReadingViewAll_gridTitle__zlChO {
  font-size: 20px;
  margin-bottom: 10px;
  color: white;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.ReadingViewAll_grid__L90q8 {
    display: grid;
    gap: 2rem;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
    grid-template-columns: repeat(7, 1fr);
}

.ReadingViewAll_bookCard__BCns6 {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.ReadingViewAll_bookCard__BCns6:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
}

.ReadingViewAll_imageContainer__D8lKy {
  overflow: hidden;
  position: relative;
}

.ReadingViewAll_imageContainer__D8lKy img {
  width: 100%;
  height: 100%;
  transition: transform 0.3s ease;
  cursor: pointer;
}

.ReadingViewAll_bookCard__BCns6:hover .ReadingViewAll_imageContainer__D8lKy img {
  transform: scale(1.05);
}

.ReadingViewAll_bookInfo__OM5Ft {
  padding: 20px;
}

.ReadingViewAll_bookTitle__DSAN1 {
  font-size: 1.4rem;
  margin-bottom: 10px;
  color: #333;
  font-weight: 600;
}

.ReadingViewAll_noBooks__0Icez {
  text-align: center;
  padding: 40px;
  font-size: 1.5rem;
  color: #666;
}

/* Swiper Overrides */
.swiper-button-next,
.swiper-button-prev {
  color: white !important;
  opacity: 0.7;
  transition: opacity 0.3s ease;
}

.swiper-button-next:hover,
.swiper-button-prev:hover {
  opacity: 1;
}

.swiper-pagination-bullet {
  background: white !important;
  opacity: 0.7;
}

.swiper-pagination-bullet-active {
  opacity: 1;
}

/* Responsive Styles */
@media (max-width: 1200px) {
  .ReadingViewAll_contentWrapper__ItHr1 {
    padding: 2rem;
    gap: 2rem;
  }

  .ReadingViewAll_title__7gKHM {
    font-size: 3rem;
  }

  .ReadingViewAll_coverImageContainer__8bumn {
    width: 350px;
    height: 525px;
  }

  .ReadingViewAll_grid__L90q8 {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
}

@media (max-width: 968px) {
  .ReadingViewAll_contentWrapper__ItHr1 {
    justify-content: center;
    text-align: center;
    padding: 1.5rem;
  }

  .ReadingViewAll_bookDetails__bAq5Y {
    max-width: 100%;
    overflow: hidden;
  }

  .ReadingViewAll_stats__r2oD3 {
    justify-content: center;
  }

  .ReadingViewAll_coverImageContainer__8bumn {
    width: 300px;
    height: auto;
  }

  .ReadingViewAll_title__7gKHM {
    font-size: 20px;
  }

  .ReadingViewAll_description__C0Kji {
    font-size: 12px;
  }

  .ReadingViewAll_grid__L90q8 {
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 20px;
  }

  .ReadingViewAll_imageContainer__D8lKy {
    height: 350px;
  }
  .ReadingViewAll_category__A4KHD{
    font-size: 12px;
  }
}

@media (max-width: 640px) {
  .ReadingViewAll_contentWrapper__ItHr1 {
    padding: 1rem;
  }

  .ReadingViewAll_coverImageContainer__8bumn {
    width: 200px;
    height: auto;
  }

  .ReadingViewAll_title__7gKHM {
    font-size: 16px;
  }

  .ReadingViewAll_author__SEBZu {
    font-size: 12px;
  }

  .ReadingViewAll_description__C0Kji {
    font-size: 12px;
  }

  .ReadingViewAll_stats__r2oD3 {
    flex-direction: column;
    gap: 0.5rem;
  }

  .ReadingViewAll_grid__L90q8 {
    grid-template-columns: repeat(3, 1fr); /* Changed from 1fr to show 3 books per row */
    gap: 10px; /* Reduced gap for mobile to fit books better */
    padding: 0rem;
  }

  .ReadingViewAll_imageContainer__D8lKy {
    height: auto; /* Changed to auto to maintain aspect ratio */
  }

  .ReadingViewAll_booksGrid__j77KZ {
  }

  .ReadingViewAll_gridTitle__zlChO {
    font-size: 14px;
  }
}

/* Added a smaller mobile breakpoint for very small screens */
@media (max-width: 480px) {
  .ReadingViewAll_grid__L90q8 {
    grid-template-columns: repeat(3, 1fr); /* Keep 3 columns even on very small screens */
    gap: 8px; /* Further reduce gap for very small screens */
  }
  
  .ReadingViewAll_bookCard__BCns6 {
    border-radius: 6px; /* Slightly smaller border radius */
  }
  
  .ReadingViewAll_imageContainer__D8lKy img {
    border-radius: 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/reading-pages/view/ReadingViewAll.module.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,SAAS;EACT,iEAAiE;;AAEnE;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,0CAA0C;EAC1C,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,cAAc;EACd,cAAc;;AAEhB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,WAAW;AACb;;AAEA,qBAAqB;AACrB;;EAEE,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,4DAA4D;EAC9D;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,qCAAqC,EAAE,6CAA6C;IACpF,SAAS,EAAE,+CAA+C;IAC1D,aAAa;EACf;;EAEA;IACE,YAAY,EAAE,6CAA6C;EAC7D;;EAEA;EACA;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,6DAA6D;AAC7D;EACE;IACE,qCAAqC,EAAE,8CAA8C;IACrF,QAAQ,EAAE,8CAA8C;EAC1D;;EAEA;IACE,kBAAkB,EAAE,mCAAmC;EACzD;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* ReadingViewAll.module.css */\n.container {\n  max-width: 100%;\n  margin-bottom: 2rem;\n}\n\n/* Showcase Styles */\n.showcase {\n  min-height: 90vh;\n  position: relative;\n}\n\n.showcaseSwiper {\n  height: 90vh;\n}\n\n.showcaseSlide {\n  position: relative;\n  height: 90vh;\n  overflow: hidden;\n}\n\n.backgroundImage {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-size: cover;\n  background-position: center;\n}\n\n.backgroundImage::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n}\n\n.contentWrapper {\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n  gap: 4rem;\n  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), #1a1a1a);\n\n}\n\n.bookDetails {\n  flex: 1;\n  color: white;\n  max-width: 600px;\n}\n\n.title {\n  font-size: 20px;\n  font-weight: bold;\n  margin-bottom: 1rem;\n  line-height: 1.2;\n}\n\n.author {\n  font-size: 16px;\n  margin-bottom: 1rem;\n  opacity: 0.9;\n}\n\n.category {\n  display: inline-block;\n  padding: 0.5rem 1rem;\n  background-color: rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n  margin-bottom: 1.5rem;\n  cursor: pointer;\n}\n\n.description {\n  font-size: 12px;\n  line-height: 1.6;\n  margin-bottom: 2rem;\n  opacity: 0.8;\n}\n\n.stats {\n  display: flex;\n  gap: 2rem;\n  font-size: 12px;\n  opacity: 0.7;\n}\n\n.coverImageContainer {\n  flex: 0 0 auto;\n  width: 400px;\n  height: auto;\n  max-height: 500px;\n  position: relative;\n}\n\n.coverImage {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 10px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n}\n\n/* Grid Section Styles */\n.booksGrid {\n  width: 100%;\n  max-width: 95%;\n  margin: 0 auto;\n \n}\n\n.gridTitle {\n  font-size: 20px;\n  margin-bottom: 10px;\n  color: white;\n  max-width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.grid {\n    display: grid;\n    gap: 2rem;\n    max-width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n    grid-template-columns: repeat(7, 1fr);\n}\n\n.bookCard {\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.bookCard:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);\n}\n\n.imageContainer {\n  overflow: hidden;\n  position: relative;\n}\n\n.imageContainer img {\n  width: 100%;\n  height: 100%;\n  transition: transform 0.3s ease;\n  cursor: pointer;\n}\n\n.bookCard:hover .imageContainer img {\n  transform: scale(1.05);\n}\n\n.bookInfo {\n  padding: 20px;\n}\n\n.bookTitle {\n  font-size: 1.4rem;\n  margin-bottom: 10px;\n  color: #333;\n  font-weight: 600;\n}\n\n.noBooks {\n  text-align: center;\n  padding: 40px;\n  font-size: 1.5rem;\n  color: #666;\n}\n\n/* Swiper Overrides */\n:global(.swiper-button-next),\n:global(.swiper-button-prev) {\n  color: white !important;\n  opacity: 0.7;\n  transition: opacity 0.3s ease;\n}\n\n:global(.swiper-button-next:hover),\n:global(.swiper-button-prev:hover) {\n  opacity: 1;\n}\n\n:global(.swiper-pagination-bullet) {\n  background: white !important;\n  opacity: 0.7;\n}\n\n:global(.swiper-pagination-bullet-active) {\n  opacity: 1;\n}\n\n/* Responsive Styles */\n@media (max-width: 1200px) {\n  .contentWrapper {\n    padding: 2rem;\n    gap: 2rem;\n  }\n\n  .title {\n    font-size: 3rem;\n  }\n\n  .coverImageContainer {\n    width: 350px;\n    height: 525px;\n  }\n\n  .grid {\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  }\n}\n\n@media (max-width: 968px) {\n  .contentWrapper {\n    justify-content: center;\n    text-align: center;\n    padding: 1.5rem;\n  }\n\n  .bookDetails {\n    max-width: 100%;\n    overflow: hidden;\n  }\n\n  .stats {\n    justify-content: center;\n  }\n\n  .coverImageContainer {\n    width: 300px;\n    height: auto;\n  }\n\n  .title {\n    font-size: 20px;\n  }\n\n  .description {\n    font-size: 12px;\n  }\n\n  .grid {\n    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n    gap: 20px;\n  }\n\n  .imageContainer {\n    height: 350px;\n  }\n  .category{\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 640px) {\n  .contentWrapper {\n    padding: 1rem;\n  }\n\n  .coverImageContainer {\n    width: 200px;\n    height: auto;\n  }\n\n  .title {\n    font-size: 16px;\n  }\n\n  .author {\n    font-size: 12px;\n  }\n\n  .description {\n    font-size: 12px;\n  }\n\n  .stats {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .grid {\n    grid-template-columns: repeat(3, 1fr); /* Changed from 1fr to show 3 books per row */\n    gap: 10px; /* Reduced gap for mobile to fit books better */\n    padding: 0rem;\n  }\n\n  .imageContainer {\n    height: auto; /* Changed to auto to maintain aspect ratio */\n  }\n\n  .booksGrid {\n  }\n\n  .gridTitle {\n    font-size: 14px;\n  }\n}\n\n/* Added a smaller mobile breakpoint for very small screens */\n@media (max-width: 480px) {\n  .grid {\n    grid-template-columns: repeat(3, 1fr); /* Keep 3 columns even on very small screens */\n    gap: 8px; /* Further reduce gap for very small screens */\n  }\n  \n  .bookCard {\n    border-radius: 6px; /* Slightly smaller border radius */\n  }\n  \n  .imageContainer img {\n    border-radius: 6px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ReadingViewAll_container__LUc1z`,
	"showcase": `ReadingViewAll_showcase__dycMG`,
	"showcaseSwiper": `ReadingViewAll_showcaseSwiper__hvBcL`,
	"showcaseSlide": `ReadingViewAll_showcaseSlide__GyR7O`,
	"backgroundImage": `ReadingViewAll_backgroundImage__99fyk`,
	"contentWrapper": `ReadingViewAll_contentWrapper__ItHr1`,
	"bookDetails": `ReadingViewAll_bookDetails__bAq5Y`,
	"title": `ReadingViewAll_title__7gKHM`,
	"author": `ReadingViewAll_author__SEBZu`,
	"category": `ReadingViewAll_category__A4KHD`,
	"description": `ReadingViewAll_description__C0Kji`,
	"stats": `ReadingViewAll_stats__r2oD3`,
	"coverImageContainer": `ReadingViewAll_coverImageContainer__8bumn`,
	"coverImage": `ReadingViewAll_coverImage__M1u+d`,
	"booksGrid": `ReadingViewAll_booksGrid__j77KZ`,
	"gridTitle": `ReadingViewAll_gridTitle__zlChO`,
	"grid": `ReadingViewAll_grid__L90q8`,
	"bookCard": `ReadingViewAll_bookCard__BCns6`,
	"imageContainer": `ReadingViewAll_imageContainer__D8lKy`,
	"bookInfo": `ReadingViewAll_bookInfo__OM5Ft`,
	"bookTitle": `ReadingViewAll_bookTitle__DSAN1`,
	"noBooks": `ReadingViewAll_noBooks__0Icez`
};
export default ___CSS_LOADER_EXPORT___;
